import { c as _c } from "react/compiler-runtime";
import { BaseButton } from '@7f-ui/components/button/button';
import { LoadingImage } from '@7f-ui/components/loading-image/loading-image';
import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';
import type { HeroImage } from '.';
const heroGridImageVariants = tv({
  slots: {
    base: 'transition-filter col-start-1 col-end-13 row-span-1 row-start-1 row-end-2 h-auto w-full overflow-hidden rounded-xl duration-100 hover:brightness-110 active:brightness-125',
    image: 'aspect-square h-auto object-cover'
  },
  variants: {
    aspectRatio: {
      'square': {
        base: 'aspect-square',
        image: 'aspect-square'
      },
      '16/9': {
        base: 'aspect-16/9',
        image: 'aspect-16/9'
      },
      '4/3': {
        base: 'aspect-4/3',
        image: 'aspect-4/3'
      }
    }
  },
  defaultVariants: {
    aspectRatio: 'square'
  }
});
export type HeroGridImageProps = VariantProps<typeof heroGridImageVariants> & {
  image: HeroImage;
  onClick?: () => void;
  className?: string;
  priority?: boolean;
};
export function HeroGridImage(t0) {
  const $ = _c(23);
  const {
    image,
    onClick,
    aspectRatio,
    className,
    priority
  } = t0;
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== aspectRatio || $[1] !== className || $[2] !== image.alt || $[3] !== image.url || $[4] !== onClick) {
    const classes = heroGridImageVariants({
      aspectRatio
    });
    T1 = BaseButton;
    t4 = classes.base({
      className
    });
    t5 = onClick;
    T0 = LoadingImage;
    t1 = image.url;
    t2 = image.alt ?? "";
    t3 = classes.image();
    $[0] = aspectRatio;
    $[1] = className;
    $[2] = image.alt;
    $[3] = image.url;
    $[4] = onClick;
    $[5] = T0;
    $[6] = T1;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    T0 = $[5];
    T1 = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
  }
  let t6;
  if ($[12] !== T0 || $[13] !== priority || $[14] !== t1 || $[15] !== t2 || $[16] !== t3) {
    t6 = <T0 src={t1} alt={t2} className={t3} fill={true} sizes="(min-width: 1440px) 828px, (min-width: 1024px) 640px, 384px" preload={priority} />;
    $[12] = T0;
    $[13] = priority;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== T1 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6) {
    t7 = <T1 className={t4} onClick={t5}>{t6}</T1>;
    $[18] = T1;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}